import { OutboundLink } from "react-ga";
import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = theme => ({
  tab: {
    textDecoration: "none",
    color: theme.colours.palette.white,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: "2rem",
    paddingRight: "2rem",
    height: "100%",
    transition: "background-color .2s linear",
    "&:hover": {
      backgroundColor: theme.hoverColor
    },
    "@media (max-width: 823px)": {
      padding: "0.35rem 0 0.35rem 0",
      width: "100%",
      transition: "visibility 0.01s"
    }
  }
});

const Tab = ({ classes, tabLink, tabName }) => (
  <OutboundLink className={classes.tab} to={tabLink} eventLabel={tabName}>
    {tabName}
  </OutboundLink>
);

Tab.propTypes = {
  classes: PropTypes.object,
  tabLink: PropTypes.string.isRequired,
  tabName: PropTypes.string.isRequired
};

Tab.defaultProps = {
  tabLink: "/",
  tabName: ""
};

export default injectSheet(styles)(Tab);



// WEBPACK FOOTER //
// ./src/components/ProductBar/Tab.jsx